import {
	AgeLabelType,
	AgeRangeType,
	GenderType,
	GranuleSizeType,
	PregnantPeriodType,
} from '@granlupo/api-client/generated/content/zeus'
import { useCallback, useMemo } from 'react'
import { Translation, useTranslate } from '../contexts/TranslationContext'

export function useRepraseAge() {
	const translate = useTranslate()

	const repo = useMemo<Record<AgeLabelType, Partial<Record<AgeRangeType, string>>>>(() => {
		return {
			[AgeLabelType.puppy]: {
				[AgeRangeType.puppyNewbornToSeven]: translate('rephrase.age.puppy.newbornToSeven'),
				[AgeRangeType.puppyEightToThirteen]: translate('rephrase.age.puppy.eightToThirteen'),
				[AgeRangeType.puppyFourteenToEight]: translate('rephrase.age.junior.fourteenToSeven'),
				[AgeRangeType.puppyFourteenToTen]: translate('rephrase.age.junior.fourteenToNine'),
				[AgeRangeType.puppyFourteenToTwelve]: translate('rephrase.age.junior.fourteenToEleven'),
				[AgeRangeType.puppyFourteenToEighteen]: translate('rephrase.age.junior.fourteenToSeventeen'),
				[AgeRangeType.puppyFourteenToTwentyFour]: translate('rephrase.age.junior.fourteenToTwentyThree'),
				[AgeRangeType.adultNinePlus]: translate('rephrase.age.adultEightPlus'),
				[AgeRangeType.adultElevenPlus]: translate('rephrase.age.adultTenPlus'),
				[AgeRangeType.adultThirteenPlus]: translate('rephrase.age.adultTwelvePlus'),
				[AgeRangeType.adultNineteenPlus]: translate('rephrase.age.adultEighteenPlus'),
				[AgeRangeType.adultTwentyFivePlus]: translate('rephrase.age.adultTwentyFourPlus'),
			} as const,
			[AgeLabelType.adult]: {
				[AgeRangeType.adultNinePlus]: translate('rephrase.age.adultEightPlus'),
				[AgeRangeType.adultElevenPlus]: translate('rephrase.age.adultTenPlus'),
				[AgeRangeType.adultThirteenPlus]: translate('rephrase.age.adultTwelvePlus'),
				[AgeRangeType.adultNineteenPlus]: translate('rephrase.age.adultEighteenPlus'),
				[AgeRangeType.adultTwentyFivePlus]: translate('rephrase.age.adultTwentyFourPlus'),
			} as const,
		} as const
	}, [translate]) // junior and adult minus one month translation - client late update

	return useCallback(
		(value?: { ageRange?: AgeRangeType | undefined; categoryLabel?: AgeLabelType | undefined }) => {
			return value?.categoryLabel && value.ageRange ? repo[value.categoryLabel][value.ageRange] : null
		},
		[repo],
	)
}

export const rephraseSize = (sizes: GranuleSizeType[]) => {
	if (sizes.length === 3) {
		return <Translation tr="rephrase.size.medium" />
	}
	if (sizes.length === 2) {
		if (sizes.includes(GranuleSizeType.S)) {
			return <Translation tr="rephrase.size.s.xs.m" />
		}
		if (sizes.includes(GranuleSizeType.L)) {
			return <Translation tr="rephrase.size.m.l.xl" />
		}
	}
	if (sizes.length === 1 && sizes.includes(GranuleSizeType.S)) {
		return <Translation tr="rephrase.size.xs.s" />
	}
	if (sizes.length === 1 && sizes.includes(GranuleSizeType.L)) {
		return <Translation tr="rephrase.size.l.xl" />
	}
	if (sizes.length === 1 && sizes.includes(GranuleSizeType.M)) {
		return <Translation tr="rephrase.size.medium" />
	}
}

export const rephraseBreastfeeding = (week: number | undefined) => {
	if (week) {
		return `${week}. týden`
	}
}

export const rephraseGender = (gender: GenderType | undefined | string) => {
	if (gender === GenderType.female) {
		return 'Fena'
	}
	if (gender === GenderType.male) {
		return 'Pes'
	}
}

export const rephrasePregnancyState = (pregnancyState: PregnantPeriodType | undefined) => {
	if (pregnancyState === PregnantPeriodType.firstHalf) {
		return '1 - 4. týden'
	}
	if (pregnancyState === PregnantPeriodType.secondHalf) {
		return '5. - 9. týden'
	}
}
